module.exports = "<div ng-messages=\"vm.integrationForm.oneToggle.$error\"\n     ng-if='vm.integrationForm.$submitted' role=\"alert\">\n    <div ng-message=\"oneFeatureSelected\">\n        <div uib-alert ng-class=\"'alert-danger'\" >\n            {{'* You must select at least one feature (pay at table, bar tab or collection)' | translate}}\n        </div>\n    </div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/integration-settings/components/children-components/types/pos-feature/pos-toggle-validation.html
// module id = 277
// module chunks = 0